export default __webpack_public_path__ + "media/f68682974ca19a9d255361a416a54251354635f51920f831155fb9d406c2c938.svg";